<template>
  <div v-if="hasError" class="flex min-h-[400px] flex-col items-center justify-center p-8 text-center">
    <div class="mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-red-100 dark:bg-red-900/20">
      <svg class="h-8 w-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.75"
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        />
      </svg>
    </div>
    <h2 class="mb-2 text-xl font-bold text-gray-900 dark:text-white">{{ t('common.somethingWentWrong') }}</h2>
    <p class="mb-6 max-w-sm text-sm text-gray-500 dark:text-gray-400">
      {{ t('common.unexpectedError') }}
    </p>
    <button
      type="button"
      class="btn-brand-primary rounded-lg px-4 py-2 text-sm font-medium transition-colors"
      @click="resetError"
    >
      {{ t('common.tryAgain') }}
    </button>
  </div>
  <slot v-else />
</template>

<script setup lang="ts">
import { ref, onErrorCaptured } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const hasError = ref(false)

function resetError(): void {
  hasError.value = false
}

onErrorCaptured((err) => {
  console.error('[ErrorBoundary] Caught component error:', err)
  hasError.value = true
  return false
})
</script>
